import { useState, type FormEvent } from 'react';

const SUBMIT_URL = 'https://readdy.ai/api/form/dah8193oh653ivfvnnl0';

interface FormResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

const categoryOptions = ['娱乐爆料', '科技数码', '财经观察', '社会热点', '生活消费', '体育赛事', '其他'];

export default function TipForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [count, setCount] = useState(0);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const guard = String(formData.get('website_alt') ?? '').trim();
    if (guard) {
      setStatus('success');
      setMessage('线索已提交，感谢你的分享！');
      form.reset();
      setCount(0);
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === 'website_alt') return;
      const text = String(value).trim();
      if (text) payload.append(key, text);
    });

    setStatus('loading');
    setMessage('正在提交…');
    try {
      const response = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: FormResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as FormResponse;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');
      if (response.ok && parsed?.code === 'OK' && !isSpam) {
        setStatus('success');
        setMessage('线索已提交，编辑会尽快核对整理，感谢你的分享！');
        form.reset();
        setCount(0);
      } else {
        setStatus('error');
        setMessage(serverMsg || '提交失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后重试。');
    }
  };

  const inputClass =
    'w-full px-4 py-3 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors';

  return (
    <form id="tip-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4" noValidate>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="tip-name" className="block text-xs font-medium text-foreground-600 mb-1.5">
            称呼
          </label>
          <input id="tip-name" name="name" type="text" required placeholder="如何称呼你" className={inputClass} />
        </div>
        <div>
          <label htmlFor="tip-email" className="block text-xs font-medium text-foreground-600 mb-1.5">
            邮箱
          </label>
          <input id="tip-email" name="email" type="email" required placeholder="便于编辑联系你" className={inputClass} />
        </div>
      </div>

      <div>
        <label htmlFor="tip-category" className="block text-xs font-medium text-foreground-600 mb-1.5">
          线索分类
        </label>
        <select id="tip-category" name="category" defaultValue="" className={inputClass} required>
          <option value="" disabled>
            请选择分类
          </option>
          {categoryOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="tip-content" className="block text-xs font-medium text-foreground-600 mb-1.5">
          线索内容
        </label>
        <textarea
          id="tip-content"
          name="content"
          required
          maxLength={500}
          rows={5}
          onChange={(e) => setCount(e.target.value.length)}
          placeholder="请写清时间、地点与信息来源，最多 500 字"
          className={`${inputClass} resize-none`}
        />
        <p className="mt-1.5 text-xs text-foreground-400 text-right">{count}/500</p>
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-guard-field"
      />

      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <button
          type="submit"
          disabled={status === 'loading'}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
        >
          <i className="ri-send-plane-line" />
          {status === 'loading' ? '提交中…' : '提交线索'}
        </button>
        {status !== 'idle' && status !== 'loading' ? (
          <p
            role="status"
            className={`text-xs ${status === 'success' ? 'text-secondary-600' : 'text-primary-600'}`}
          >
            {message}
          </p>
        ) : null}
      </div>
    </form>
  );
}